import { render } from "./PostSubscriptionsSection.vue?vue&type=template&id=79ef6b1e"
import script from "./PostSubscriptionsSection.vue?vue&type=script&lang=js"
export * from "./PostSubscriptionsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__